import React, { useState } from "react";
import { TiArrowSortedDown } from "react-icons/ti";
import { TiArrowSortedUp } from "react-icons/ti";
import { ApartmentsTypes } from "../../Data/ApartmentsTypes";

const LeftSideFilterListItem = ({
  label,
  fillters,
  setFillters,
  selectedProject,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const checkboxChangeHandler = (type, value) => {
    setFillters((prev) => {
      const prevValueArray = prev[type];
      let valueIndex;
      if (type === "sizes") {
        valueIndex = prevValueArray.findIndex((item) => item.min === value.min);
      } else {
        valueIndex = prevValueArray.findIndex((item) => item === value);
      }

      if (valueIndex === -1) {
        prevValueArray.push(value);
      } else {
        prevValueArray.splice(valueIndex, 1);
      }
      return { ...prev, [type]: prevValueArray };
    });
  };
  const checkboxIsChecked = (type, value) => {
    const prevValueArray = fillters[type];
    let valueIndex;
    if (type === "sizes") {
      valueIndex = prevValueArray.findIndex((item) => item.min === value.min);
    } else {
      valueIndex = prevValueArray.findIndex((item) => item === value);
    }

    if (valueIndex === -1) {
      return false;
    } else {
      return true;
    }
  };

  return (
    <>
      <li className="text-xl font-medium tracking-wider border-b-2 border-b-primary-dark/30 border-opacity-30 px-6 py-8 ">
        <div
          className="w-full h-full group flex items-center justify-between cursor-pointer"
          onClick={() => setIsExpanded((prev) => !prev)}
        >
          <span>{label}</span>
          <span>
            {isExpanded ? <TiArrowSortedUp /> : <TiArrowSortedDown />}
          </span>
        </div>
        {isExpanded && (
          <ul
            className={`w-full  ${
              label === "საძინებლის რაოდენობა" || label === "ფართის მიხედვით"
                ? "flex flex-col items-start justify-start gap-4"
                : "grid grid-cols-3 gap-4"
            }  px-2 mt-4`}
          >
            {label === "საძინებლის რაოდენობა" && (
              <>
                {ApartmentsTypes[selectedProject.name].apartmentsArray.map(
                  (type) => {
                    return (
                      <li
                        key={type.id}
                        className="w-fit flex items-center justify-start gap-4 py-2 cursor-pointer"
                      >
                        <input
                          type="checkbox"
                          id={type.name}
                          name="type"
                          value={type.name}
                          checked={checkboxIsChecked("types", type.id)}
                          className="cursor-pointer h-5 w-5 appearance-none border-2 border-gray-500 rounded-md checked:bg-primary-bg-green checked:border-transparent "
                          onChange={(e) =>
                            checkboxChangeHandler("types", type.id)
                          }
                        />
                        <label htmlFor={type.name} className="cursor-pointer">
                          {type.label}
                        </label>
                      </li>
                    );
                  }
                )}
              </>
            )}
            {label === "სართული" && (
              <>
                {selectedProject.floors.map((floor) => {
                  return (
                    <li
                      key={floor.floorNumber}
                      className="col-span-1 max-w-min flex items-center justify-start gap-4 py-2 cursor-pointer border-x-2 border-primary-dark/50 px-1 rounded-lg"
                    >
                      <input
                        type="checkbox"
                        id={floor.floorNumber}
                        name="floor"
                        value={floor.floorNumber}
                        checked={checkboxIsChecked(
                          "floors",
                          Number(floor.floorNumber)
                        )}
                        className="cursor-pointer h-5 w-5 appearance-none border-2 border-gray-500 rounded-md checked:bg-primary-bg-green checked:border-transparent "
                        onChange={(e) =>
                          checkboxChangeHandler(
                            "floors",
                            Number(e.target.value)
                          )
                        }
                      />
                      <label
                        htmlFor={floor.floorNumber}
                        className="cursor-pointer "
                      >
                        {floor.floorNumber}
                      </label>
                    </li>
                  );
                })}
              </>
            )}
            {label === "ფართის მიხედვით" && (
              <>
                {ApartmentsTypes[selectedProject.name].apartmentsArray.map(
                  (type) => {
                    return (
                      <li
                        key={type.id}
                        className="w-fit flex items-center justify-start gap-4 py-2 cursor-pointer"
                      >
                        <input
                          type="checkbox"
                          id={type.subType[0].size}
                          name="sizes"
                          value={type.name}
                          checked={checkboxIsChecked("sizes", {
                            min: type.subType[0].size,
                            max: type.subType[type.subType.length - 1].size,
                          })}
                          className="cursor-pointer h-5 w-5 appearance-none border-2 border-gray-500 rounded-md checked:bg-primary-bg-green checked:border-transparent "
                          onChange={(e) =>
                            checkboxChangeHandler("sizes", {
                              min: type.subType[0].size,
                              max: type.subType[type.subType.length - 1].size,
                            })
                          }
                        />
                        <label
                          htmlFor={type.subType[0].size}
                          className="cursor-pointer"
                        >
                          {type.subType[0].size} -{" "}
                          {type.subType[type.subType.length - 1].size}
                        </label>
                      </li>
                    );
                  }
                )}
              </>
            )}
          </ul>
        )}
      </li>
    </>
  );
};

export default LeftSideFilterListItem;
